import React from 'react';
import { Container } from 'reactstrap';

import { useSelector } from 'react-redux';
import {
  isAdmin as isAdminSelector,
  isManager as isManagerSelector,
  isAnalyst as isAnalystSelector,
  isPublisher as isPublisherSelector,
  isTeamLeader as isTeamLeaderSelector,
} from '../../selectors/auth';
import AdminLeads from './admin';
import PublisherLeads from './publisher';

const List = (props) => {
  const isAdmin = useSelector(isAdminSelector);
  const isManager = useSelector(isManagerSelector);
  const isTeamLeader = useSelector(isTeamLeaderSelector);
  const isPublisher = useSelector(isPublisherSelector);
  const isAnalyst = useSelector(isAnalystSelector);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {(isAdmin || isManager || isAnalyst || isTeamLeader) && (
            <AdminLeads />
          )}
          {isPublisher && <PublisherLeads />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default List;
